const temas = [
  {
    titulo: "Tema 1: Introducción",
    to: "/python/tema-1",
    material: "doc/Material_complementario_tema_1.docx",
    pdf: "Tema1_Introduccion.pdf",
  },
  {
    titulo: "Tema 2: Primeros Conceptos",
    to: "/python/tema-2",
    material: "doc/Material_complementario_tema_2.docx",
    pdf: "Tema2_Primeros_Conceptos.pdf",
  },
  {
    titulo: "Tema 3: Programación Básica",
    to: "/python/tema-3",
    material: "doc/Material_complementario_tema_3.docx",
    pdf: "Tema3_Programacion_Basica.pdf",
  },
  {
    titulo: "Tema 4: Funciones",
    to: "/python/tema-4",
    material: "doc/Material_complementario_tema_4.docx",
    pdf: "Tema4_Funciones.pdf",
  },
  {
    titulo: "Tema 5: Organización de Código",
    to: "/python/tema-5",
    material: "doc/Material_complementario_tema_5.docx",
    pdf: "Tema5_Organizacion_Codigo.pdf",
  },
  {
    titulo: "Tema 6: Aspectos Avanzados",
    to: "/python/tema-6",
    material: "doc/Material_complementario_tema_6.docx",
    pdf: "Tema6_Aspectos_Avanzados.pdf",
  },
  {
    titulo: "Tema 7: Análisis de Datos",
    to: "/python/tema-7",
    material: "doc/Material_complementario_tema_7.docx",
    pdf: "Tema7_Analisis_Datos.pdf",
  },
  {
    titulo: "Tema 8: Visualización de Datos",
    to: "/python/tema-8",
    material: "doc/Material_complementario_tema_8.docx",
    pdf: "Tema8_Visualizacion_Datos.pdf",
  },
];

export default temas;
